<script setup lang="ts"></script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="214"
    height="44"
    viewBox="0 0 214 44"
    fill="none"
  >
    <g clip-path="url(#clip0_1635_295)">
      <path
        d="M67.2902 8.81152C60.0849 8.81152 54.2598 14.7191 54.2598 22C54.2598 29.2809 60.0849 35.1783 67.2902 35.1783C74.4956 35.1783 80.3207 29.2708 80.3207 22C80.3207 14.7292 74.4956 8.81152 67.2902 8.81152ZM67.2902 30.7351C62.5611 30.7351 58.725 26.8169 58.725 22C58.725 17.1831 62.551 13.2548 67.2902 13.2548C72.0295 13.2548 75.8554 17.173 75.8554 22C75.8554 26.827 72.0295 30.7351 67.2902 30.7351Z"
        fill="#222F3E"
      ></path>
      <path
        d="M114.278 9.24585V34.7442H109.924V15.8199L101.43 34.7442H96.8022L88.3385 15.9613V34.7442H83.9849V9.24585H89.8709L99.1363 29.796L108.361 9.24585H114.278Z"
        fill="#222F3E"
      ></path>
      <path
        d="M142.124 9.24585V34.7442H137.111L123.603 15.6179V34.7442H119.25V9.24585H124.364L137.77 28.1702V9.24585H142.124Z"
        fill="#222F3E"
      ></path>
      <path
        d="M147.097 34.7543V9.24585H151.592V34.7442H147.097V34.7543Z"
        fill="#222F3E"
      ></path>
      <path
        d="M177.755 34.7542H173.229L171.839 30.3513H160.97L159.437 34.7542H154.881L163.761 9.25586H169.505L177.755 34.7542ZM170.651 26.6149L166.612 13.9314L162.188 26.6149H170.651Z"
        fill="#222F3E"
      ></path>
      <path
        d="M181.043 34.7543V9.24585H185.539V34.7442H181.043V34.7543Z"
        fill="#222F3E"
      ></path>
      <path
        d="M200.6 9.24585C202.548 9.24585 204.324 9.5488 205.927 10.1648C207.531 10.7808 208.901 11.6392 210.038 12.75C211.174 13.8608 212.057 15.2039 212.686 16.7691C213.315 18.3445 213.63 20.0814 213.63 22.0001C213.63 23.9188 213.315 25.6658 212.686 27.231C212.057 28.8064 211.174 30.1394 210.038 31.2502C208.901 32.361 207.531 33.2194 205.927 33.8354C204.324 34.4514 202.548 34.7543 200.6 34.7543H190.502V9.24585H200.6ZM200.813 30.9674C202.061 30.9674 203.198 30.7554 204.212 30.3312C205.227 29.9071 206.09 29.3012 206.82 28.5135C207.551 27.7259 208.119 26.7766 208.505 25.6759C208.901 24.5651 209.094 23.3432 209.094 22.0001C209.094 20.657 208.901 19.4351 208.505 18.3243C208.109 17.2135 207.551 16.2642 206.82 15.4866C206.09 14.699 205.217 14.0931 204.212 13.6689C203.198 13.2448 202.071 13.0327 200.813 13.0327H194.856V30.9775H200.813V30.9674Z"
        fill="#222F3E"
      ></path>
      <mask
        id="mask0_1635_295"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="45"
        height="44"
      >
        <path
          d="M22.2122 43.8832C10.0849 43.8832 0.220703 34.0676 0.220703 22.0001C0.220703 9.93255 10.0849 0.116943 22.2122 0.116943C34.3394 0.116943 44.2036 9.93255 44.2036 22.0001C44.2036 34.0676 34.3394 43.8832 22.2122 43.8832ZM9.46584 35.6632C12.2363 38.1979 16.8031 40.8234 21.7149 40.8234C22.679 40.8234 23.6329 40.7225 24.5463 40.5205C27.5806 39.8439 31.3558 37.7636 32.9592 34.6533C33.9741 32.6741 34.0451 30.4827 33.1724 28.1399C29.4479 33.0275 22.1919 36.1681 14.4994 36.1681C12.7438 36.1681 11.049 36.0065 9.46584 35.6733V35.6632ZM35.1919 24.8175C36.6431 27.8672 37.3129 30.816 35.9632 34.8654C40.398 29.9778 42.9655 21.9799 39.17 14.0224C35.1716 5.64075 27.4182 3.82304 23.3792 3.4696C28.3925 5.07524 32.3808 8.10475 34.7656 12.1744C36.978 16.0926 37.1302 20.5762 35.1919 24.8276V24.8175ZM6.09659 31.5026C8.23789 31.9874 10.4096 32.2398 12.5509 32.2398C20.3449 32.2398 27.469 28.9074 30.7976 23.7269C28.3417 20.9802 23.9475 17.6881 16.7422 17.1832C16.3566 17.1529 15.9709 17.1428 15.5853 17.1428C10.5416 17.1428 5.91392 19.4957 3.46817 21.5356C3.38699 25.0296 4.29019 28.4731 6.09659 31.5026ZM16.4783 13.8305C22.3238 13.8305 28.017 16.3147 32.1575 20.657C32.9389 18.3041 32.3097 14.9918 30.483 12.033C27.8546 7.7715 23.5213 5.15603 18.6095 4.87327C18.3761 4.86317 18.1528 4.85308 17.9296 4.85308C10.1356 4.85308 5.17309 12.4773 3.85381 18.3748C7.31439 15.4362 11.7594 13.8305 16.4783 13.8305Z"
          fill="white"
        ></path>
      </mask>
      <g mask="url(#mask0_1635_295)">
        <path
          d="M31.0517 61.7775C52.1312 61.7775 69.2196 44.7733 69.2196 23.7976C69.2196 2.82182 52.1312 -14.1824 31.0517 -14.1824C9.97214 -14.1824 -7.11621 2.82182 -7.11621 23.7976C-7.11621 44.7733 9.97214 61.7775 31.0517 61.7775Z"
          fill="url(#paint0_radial_1635_295)"
        ></path>
      </g>
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_1635_295"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(31.0517 23.7976) scale(38.1679 37.9799)"
      >
        <stop offset="0.04" stop-color="#0084FF"></stop>
        <stop offset="0.76" stop-color="#B1E4FC"></stop>
        <stop offset="0.91" stop-color="#D6F8FC"></stop>
      </radialGradient>
      <clipPath id="clip0_1635_295">
        <rect width="213.84" height="44" fill="white"></rect>
      </clipPath>
    </defs>
  </svg>
</template>
